import { createSelector } from 'reselect'
import {
  getSelectedFacetNameAttributes,
  getFacetNameAttributesList,
} from 'selectors/algolia2/facets'

export const isColorValueSelected = (facetColor: string) =>
  createSelector(
    [getSelectedFacetNameAttributes('color')],
    (colors): boolean => colors.includes(facetColor) || false
  )

export const getAvailableColors = createSelector(
  [getFacetNameAttributesList('color')],
  (colors): Array<string> => colors
)

export const isColorValueAvailable = (facetColor: string) =>
  createSelector([getAvailableColors], (colors): boolean => colors.includes(facetColor) || false)
